module.exports = "/img/item-6.a9a858bf.png";